<template>
	<div class="us-item" :class="{ 'us-item-selected': selected }">
		<img v-if="item.avatar" :src="item.avatar" class="us-avatar us-avatar-img" :alt="item.login">
		<sym-icon v-else-if="item.icon" :name="item.icon" class="us-avatar us-avatar-icon"></sym-icon>
		<div class="us-item-desc" :class="{'us-item-desc-expand':hasExpand}">
			<div class="us-item-title">{{ item.name }}</div>
			<div v-if="hasExpand" class="us-item-expand">
				<icon-button v-for="ex in item.expanders" :key="ex.query" @click.prevent.stop="doExpansion(ex.query)" :name="ex.icon"></icon-button>
			</div>
			<div v-if="Array.isArray(item.info)" class="us-item-info">
				<template v-for="(info, idx) in item.info">
					<span v-if="idx>0" class="info-comma">,</span>
					<span class="info-info">{{ info }}</span>
				</template>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import {ref, computed} from "vue";
import IconButton from "@fd/helpers/IconButton.vue";
import {SuggestedUserParty} from "@t/fd/editor/UserSelect.ts";
import SymIcon from "@fd/helpers/SymIcon.vue";

const props = defineProps<{
	item: SuggestedUserParty,
	selected: boolean
}>();
const emit = defineEmits(['expand']);

const hasExpand = computed<boolean>(() => {
	return Array.isArray(props.item.expanders) && props.item.expanders.length > 0;
});

function doExpansion(query: string) {
	console.log("doExpansion", query);
	emit('expand', query);
}
</script>

<style>

.fd-user-select-drop {
	& > .us-item {
		padding: 4px 8px 4px 30px;
		position: relative;
		cursor: pointer;

		&.us-item-selected {
			background-color: var(--drop-bg-selection);
			color: var(--drop-fg-selection);
			--link-fg: var(--drop-fg-selection);
		}

		& > .us-avatar {
			position: absolute;
			width: 18px;
			height: 18px;
			border-radius: 50%;
			top: 4px;
			left: 8px;
		}
	}
}

.us-item-desc {
	display: grid;
	grid-template-columns: 1fr max-content;

	& > .us-item-title {
		font-weight: 500;
		grid-column: 1 / 3;
		grid-row: 1 / 2;
	}

	&.us-item-desc-expand {
		& > .us-item-title {
			grid-column: 1 / 2;
		}
		& > .us-item-expand {
			justify-self: end;
			grid-column: 2 / 3;
			grid-row: 1 / 2;
			opacity: 0.5;

			&:hover {
				opacity: 1;
			}
		}
	}

	& > .us-item-info {
		font-size: var(--font-size-s);
		grid-column: 1 / 3;
		grid-row: 2 / 3;
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
	}
}
.info-info { opacity: 0.66; }
.info-comma {
	opacity: 0.5;
	padding-right: 4px;
}
</style>